<template>
    <div v-if="statement_settings">
        <kt-panel>
            <kt-panel-body>
                <form id="update_settings_form">
                    <kt-row style="margin-top: 20px">
                        <kt-col xs="12" sm="6" md="4" lg="3">
                            <kt-form-group>
                                <kt-form-label>
                                    {{ $t('application.statement_period') }}
                                </kt-form-label>
                                <kt-form-select
                                    size="4"
                                    id="statement_period"
                                    name="statement_period"
                                    v-model="statement_settings.statement_period"
                                >
                                    <option
                                        v-bind:key="index"
                                        v-for="(statement_period, index) in statement_period_types"
                                        v-bind:value="statement_period.value"
                                        :selected="statement_period.value"
                                    >
                                        {{ statement_period.name }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </kt-col>
                        <kt-col xs="12" sm="6" md="6" lg="6">
                            <kt-form-group style="margin-top: 35px">
                                <div class="custom-control custom-switch">
                                    <input
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="automate_verify"
                                        name="automate_verify"
                                        v-model="statement_settings.automate_verify"
                                    >
                                    <label style="font-size: smaller" class="custom-control-label"
                                           for="automate_verify">{{
                                            $t('application.automate_verify')
                                        }}</label>
                                </div>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                    <hr/>
                    <kt-row style="margin-top: 20px">
                        <kt-col lg="12">
                            <p class="col-12" style="margin-bottom: 10px;font-weight: bold;font-size: 15px">
                                {{ $t('application.credit_verification_bak_accounts') }}
                            </p>
                            <kt-row>
                                <kt-col v-bind:key="index" v-for="(bank_account, index) in active_bank_accounts" lg="12"
                                        md="12" xs="12"
                                        style="margin-top: 10px">
                                    <div class="custom-control custom-checkbox"
                                         id="iban_inquiry-div">
                                        <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            :id="bank_account.id"
                                            :name="bank_account.id"
                                            v-model="bank_account.is_selected"
                                        >
                                        <label class="custom-control-label" :for="bank_account.id"
                                               style="padding-top: 3px">
                                            {{
                                                bankIdStr.get(bank_account.bank_id) + '&nbsp;&nbsp;&nbsp;' + bank_account.account_number
                                            }}
                                        </label>
                                    </div>
                                </kt-col>
                            </kt-row>
                        </kt-col>
                    </kt-row>
                    <kt-form-action style="text-align: end">
                        <button class="btn btn-md btn-success" type="button"
                                @click="edit"
                                id="update_settings_btn">
                            {{ $t('btn.edit') }}
                        </button>
                    </kt-form-action>
                </form>
            </kt-panel-body>
        </kt-panel>
    </div>
</template>

<script>
import {KTUtil} from '@/plugins/core/util';
import {KTApp} from "@/plugins/core/app";
import {openBankingService} from "@/common/api.service";
import {bankIdStr} from '@/constants/bankId'
import $ from "jquery";
import toastr from "toastr";
import {i18n} from '@/plugins/i18n';
import {mapGetters} from "vuex";

export default {
    components: {},
    props: ['bank_accounts'],
    mounted() {
        this.fetchSettings();
    },
    data() {
        return {
            'hashid': this.$route.params.hashid,
            statement_settings: null,
            bankIdStr,
            active_bank_accounts: null,
            statement_period_types: [
                {
                    name: this.$t('application.statement_period_types.every_five_minutes'),
                    value: 1
                },
                {
                    name: this.$t('application.statement_period_types.every_fifteen_minutes'),
                    value: 2
                },
                {
                    name: this.$t('application.statement_period_types.every_thirty_minutes'),
                    value: 3,
                },
                {
                    name: this.$t('application.statement_period_types.every_hours'),
                    value: 4,
                }
            ],
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    methods: {
        edit() {
            let btn = $('#update_settings_btn')
            let form = $('#update_settings_form')

            form.validate({
                rules: {
                    statement_period: {
                        required: true
                    }
                }
            });

            if (!form.valid()) {
                return
            }
            KTApp.progress(btn)
            let active_bank_account_ids = [];
            this.active_bank_accounts.forEach(bank_account => {
                if (bank_account.is_selected) {
                    active_bank_account_ids.push(bank_account.id)
                }
            });

            this.statement_settings.bank_account_ids = active_bank_account_ids;
            let params = {
                automate_verify: this.statement_settings.automate_verify,
                statement_period: this.statement_settings.statement_period,
                bank_account_ids : active_bank_account_ids
            }
            if (params.automate_verify === null) {
                params.automate_verify = false
            }

            openBankingService.adminUpdateApplicationStatementSetting(this.hashid, params).then(response => {
                this.showMsg(form, 'success', response.data.message);
                this.fetchSettings()
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message);
            }).finally(response => {
                KTApp.unprogress(btn)
                KTUtil.scrollTop();
            })
        },
        afterDispatch() {
            $('.kt-selectpicker-app-details').selectpicker({
                size: 4,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        setActiveBankAccounts() {
            let accounts = []
            this.bank_accounts.forEach(bank_account => {
                let is_selected = false;
                if (this.statement_settings.bank_account_ids.includes(bank_account.id)) {
                    is_selected = true;
                }
                accounts.push({
                    account_number: bank_account.account_number,
                    id: bank_account.id,
                    is_selected: is_selected,
                    bank_id: bank_account.bank_id,
                })
            });

            this.active_bank_accounts = accounts;
        },

        fetchSettings() {
            openBankingService.adminGetApplicationStatementSetting(this.hashid).then(response => {
                this.statement_settings = response.data.data.statement_settings;
                this.setActiveBankAccounts();
                this.afterDispatch()
            });
        }
    }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>